import React, { Fragment, useEffect, useState } from "react";
import { oneOfType, string, func, bool, arrayOf, shape } from "prop-types";
import { connect, useDispatch } from "react-redux";
// import { push } from "connected-react-router";
import { REGION_ARG } from "constants.js";

import { actions as loansActions, selectors as loansSelectors } from "reducers/loans";
import { selectors as settingsSelectors, actions as settingsActions } from "reducers/settings";
import { actions as environmentActions } from "reducers/environment";

import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import TextField from "pages/_components/fields/TextField";
import PhoneInput from "pages/_components/fields/PhoneInput";
import Selector from "pages/_components/fields/formik/Selector";
import * as configUtils from "util/config";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Row, Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import Credential from "pages/_components/fields/credentials/Credential";
import * as i18n from "util/i18n";
import { ResponsiveHeader } from "pages/_components/header";
import Box from "pages/_components/Box";

const FORM_ID = "loans";
const OtrosProductos = ({
    mobilePhone,
    mail,
    clientName,
    clientLastName,
    // isDesktop,
    isMobile,
    fetching,
    documentNumber,
    newAccountRequiredCredentials,
    statusLoan,
    dataAll,
    loading,
    defaultOtherProduct,
}) => {
    const formRef = React.createRef();
    const [availableProductTypes, setAvailableProductTypes] = useState([]);
    const dispatch = useDispatch();
    const isLoading = fetching;
    const defaultPhoneNumber = mobilePhone;
    const credentialType = newAccountRequiredCredentials.includes("otp") ? "otp" : "password";
    useEffect(() => {
        dispatch(accountsActions.fetchCredentialGroup());
        dispatch(settingsActions.getUserData());
        dispatch(environmentActions.getComplementaryDataSelectors());
        setAvailableProductTypes(
            configUtils
                .getArray("loan.productTypes")
                .reduce(
                    (allTypes, newType) => [
                        ...allTypes,
                        { value: newType, label: i18n.get(`loan.productTypes.${newType}`) },
                    ],
                    [],
                ),
        );
    }, []);
    useEffect(
        () => () => {
            dispatch(settingsActions.setDefaultOtherProduct(""));
        },
        [],
    );
    useEffect(() => {
        if (mail && clientName && formRef.current) {
            formRef.current.setFieldValue("email", mail);
            formRef.current.setFieldTouched("email", false, false);
            formRef.current.setFieldValue("lastname", clientLastName);
            formRef.current.setFieldTouched("lastname", false, false);
            formRef.current.setFieldValue("document", documentNumber);
            formRef.current.setFieldTouched("document", false, false);
            formRef.current.setFieldValue("name", clientName);
            formRef.current.setFieldTouched("name", false, false);
            formRef.current.setFieldValue("phone", { prefix: "", value: mobilePhone });
            formRef.current.setFieldTouched("phone", false, false);
        }
    }, [clientName, clientLastName, mail]);
    useEffect(() => {
        if (statusLoan && statusLoan === "INVALID_CREDENTIAL") {
            formRef.current.setErrors({
                credential: i18n.get(
                    credentialType === "password"
                        ? "preferences.password.password.incorrect"
                        : "login.step1.secondFactor.invalid",
                ),
            });
            formRef.current.setFieldTouched("credential", true, true);
        }
    }, [statusLoan]);
    const handleOnSubmit = (formikPropsParam, event, data) => {
        event.stopPropagation();
        // [`_${credentialType}`]: credential,
        formikPropsParam.onSubmit(event, data);
    };

    const validateForm = (val) => {
        if (val === "" || val === null || val === undefined) {
            return false;
        }
        if (val.split("").filter((x) => x === "9").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "8").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "7").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "6").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "5").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "4").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "3").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "2").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "1").length > 6) {
            return false;
        }
        if (val.split("").filter((x) => x === "0").length > 6) {
            return false;
        }
        return true;
    };
    const formikValidateProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            name: clientName,
            lastname: clientLastName,
            document: documentNumber,
            phoneNumber: {
                countryCode: "",
                areaCode: "",
                value: mobilePhone,
            },
            email: mail,
            typeProduct: defaultOtherProduct,
            comment: "",
            credential: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                name: Yup.string(),
                lastname: Yup.string(),
                document: Yup.string(),
                comment: Yup.string().required(i18n.get("global.error.required")),
                credential: Yup.string().required(i18n.get("global.error.required")),
                typeProduct: Yup.string().required(i18n.get("global.error.required")),
                phoneNumber: Yup.object().shape({
                    prefix: Yup.string(),
                    value: Yup.string()
                        .required(i18n.get("onboarding.step.verifySMS.mobilePhone.error.empty"))
                        .test("date", i18n.get("Formato de teléfono inválido"), (value) => validateForm(value)),
                }),

                email: Yup.string().required(i18n.get("global.error.required")),
            }),
        onSubmit: (values, data) => {
            const { name, lastname, document, comment, credential, typeProduct, email, phoneNumber } = data;
            if (Object.entries(formRef.current.state.errors).length === 0) {
                const { countryCode, areaCode, value } = phoneNumber;

                dispatch(
                    loansActions.setOtrosProductos(
                        email,
                        credential,
                        `+${countryCode}${areaCode}${value}`,
                        comment,
                        typeProduct,
                        name,
                        lastname,
                        document,
                        dataAll,
                    ),
                );
                return; 
            }
            const errores = Object.entries(formRef.current.state.errors);
            for (let i = 0; i < errores.length; i++) {
                formRef.current.setFieldTouched(errores[i][0], true, false);
            }
        },
    };
    return (
        <Fragment>
            <Notification scopeToShow="loans" />
            <ResponsiveHeader id="loans.otherProducts.title" backLinkTo="/desktop" />
            <MainContainer showLoader={isLoading} className="desktop">
                <Formik {...formikValidateProps} ref={formRef}>
                    {(allFormik) => (
                        <Form className="above-the-fold" noValidate>
                            <Box className={isMobile ? "box box-shadow px-6 pt-8" : "box box-shadow px-13 pt-10 grid gap-8"}>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="name"
                                            labelTextDefault={`${i18n.get(
                                                "forms.template.templateName.label",
                                                "Nombre",
                                            )}`}
                                            disabled
                                            hidePlaceholder
                                        />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="lastname"
                                            labelTextDefault={`${i18n.get(
                                                "administration.users.export.lastName",
                                                "Apellido",
                                            )}`}
                                            disabled
                                            hidePlaceholder
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="document"
                                            labelTextDefault={`${i18n.get(
                                                "checks.control.document",
                                                "Documento de Identidad",
                                            )}`}
                                            disabled
                                            hidePlaceholder
                                        />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={PhoneInput}
                                            idForm={FORM_ID}
                                            name="phoneNumber"
                                            country={REGION_ARG}
                                            mobilePhone={defaultPhoneNumber || "54"}
                                            enableSearch={false}
                                            preferredCountries={["ar"]}
                                            labelTextDefault={i18n.get(
                                                "administration.users.invite.mobilePhone.label",
                                                "Celular",
                                            )}
                                            hintLabel={i18n.get(
                                                "onboarding.step.verifySMS.mobilePhone.description",
                                                "Debes incluir el código de área y luego el número.",
                                            )}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="email"
                                            labelTextDefault={`${i18n.get(
                                                "global.email.label",
                                                "Correo electrónico",
                                            )}`}
                                            hidePlaceholder
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <Field
                                            component={Selector}
                                            renderAs="combo"
                                            inLineControl
                                            idForm={FORM_ID}
                                            name="typeProduct"
                                            options={availableProductTypes}
                                            placeholder={`${i18n.get(
                                                "onboarding.taxData.selectorPlaceholder",
                                                "Elegir una opción",
                                            )}`}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <Field
                                            component={TextField}
                                            renderAs="textarea"
                                            name="comment"
                                            idForm={FORM_ID}
                                            className="data-label"
                                            hidePlaceholder
                                            labelTextDefault={`${i18n.get("accounts.create.messageToBank", "Mensaje al Banco")}`}
                                            maxLength={200}
                                            hintLabel={i18n.get("", "Máximo de 200 caracteres.")}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="box info py-6 my-3">
                                            <CustomData
                                                icon="information_fill.svg"
                                                titleText={"loans.otherProducts.warning"}
                                                titleTextType="I18N"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Box>

                            <Row style={{ alignItems: "start" }}>
                                <Col lg={4} lgOffset={2}>
                                    <Field
                                        component={Credential}
                                        idForm={FORM_ID}
                                        labelText={`form.credential.${credentialType}.label`}
                                        // labelTextDefault={`${i18n.get("", "Contraseña")}`}
                                        placeholderText={credentialType === "otp" ? "Ej: 120573" : "Ej: Ju@n_123"}
                                        name="credential"
                                        type={credentialType}
                                    />
                                </Col>
                                <Col lg={4}>
                                    <div style={{ height: "24px" }} />
                                    <Button
                                        className="loans__button-submit"
                                        bsStyle="primary"
                                        label="global.send"
                                        loading={loading}
                                        onClick={(ev) => handleOnSubmit(formikValidateProps, ev, allFormik.values)}
                                        block
                                        id="submit-button"
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </Fragment>
    );
};
OtrosProductos.propTypes = {
    dispatch: func.isRequired,
    mobilePhone: string.isRequired,
    mail: string.isRequired,
    clientName: string.isRequired,
    clientLastName: string.isRequired,
    documentNumber: string.isRequired,
    statusLoan: string.isRequired,
    newAccountRequiredCredentials: arrayOf(string).isRequired,
    dataAll: arrayOf(shape({})).isRequired,
    // isDesktop: oneOfType([string, bool]),
    isMobile: oneOfType([string, bool]),
    fetching: oneOfType([string, bool]),
    loading: bool,
};

OtrosProductos.defaultProps = {
    // isDesktop: false,
    isMobile: false,
    fetching: false,
    loading: false,
};
const mapStateToProps = (state) => ({
    fetching: settingsSelectors.isFetching(state),
    loading: loansSelectors.getFetching(state),
    mobilePhone: settingsSelectors.getMobilePhone(state) || "",
    mail: settingsSelectors.getEmail(state) || "",
    newAccountRequiredCredentials: accountsSelectors.getNewAccountRequiredCredentials(state),
    clientLastName: settingsSelectors.getLastName(state) || "",
    clientName: settingsSelectors.getName(state) || "",
    documentNumber: settingsSelectors.getDocument(state) || "",
    statusLoan: loansSelectors.getStatusLoan(state) || "",
    dataAll: settingsSelectors.getDataAll(state) || {},
    defaultOtherProduct: settingsSelectors.getDefaultOtherProduct(state) || "",
});

export default connect(mapStateToProps)(OtrosProductos);
